
<template  >
  <div class="navigation-drawer">
    <v-navigation-drawer
      app
      v-model="navDrawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      clipped-left
    >
      <div class="drawer-institute mt-4">
        <img :src="currentInstitution.logo" width="100" />
        <h4>{{ currentInstitution.name }}</h4>
      </div>

      <v-list shaped dense>
        <template>
          <div v-for="item in navItems" :key="item.id">
            <div v-if="item.requiredPermission == undefined || currentUser.privileges[item.requiredPermission] || currentUser.privileges[item.alternateRequiredPermission]">
              <v-list-group
                v-if="item.children"
                :key="item.text"
                v-model="item.model"
                align="start"
              >
                <template v-slot:activator>
                  <component class="mr-5 my-3" :is="item.icon" height="27px" width="27px" />
                  <v-list-item-content>
                    <v-list-item-title class="nav-title">{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <div v-for="(child, i) in item.children" :key="i">
                  <v-list-item
                    dense
                    v-if="child.requiredPermission == undefined || currentUser.privileges[child.requiredPermission]"
                    link
                    align="start"
                    :to="child.link"
                    :exact="child.exact"
                  >
                    <v-list-item-action>
                      <component :is="child.icon" height="27px" width="27px" />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ child.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>

              </v-list-group>

              <v-list-item
                color="primary"
                v-else
                :key="item.text"
                link
                align="start"
                :to="item.link"
              >
                    <component class="mr-5 my-3" :is="item.icon" height="27px" width="27px" />
                <v-list-item-content>
                  <v-list-item-title class="nav-title">{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </template>
        <!-- Web App -->
      </v-list>
      <v-divider />
      <v-list shaped dense>
        <template>


          <div v-for="item in hrefItems" :key="item.id">
            <!-- <v-row v-if="item.heading" :key="item.heading" align="start">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row> -->

            <v-list-group
              v-if="item.children"
              :key="item.text"
              v-model="item.model"
              align="start"
            >
              <template v-slot:activator>
                <v-list-item-action>
                  <component :is="item.icon" height="30px" width="30px" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="nav-title">{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                link
                align="start"
                :to="child.link"
              >
                <v-list-item-action>
                  <component :is="child.icon" height="30px" width="30px" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item
              color="primary"
              v-else
              :key="item.id"
              link
              align="start"
              :href="item.href"
              :target="item.target"
            >
              <v-list-item-action>
                <component :is="item.icon" height="30px" width="30px" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="nav-title">{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <!-- Web App -->
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NavigationDrawer",
  components: {
    StudentsIcon: () => import("@components/icons/StudentIcon"),
    StaffIcon: () => import("@components/icons/StaffIcon"),
    ClassroomsIcon: () => import("@components/icons/ClassroomsIcon"),
    FeesIcon: () => import("@components/icons/FeesIcon"),
    AdmissionsIcon: () => import("@components/icons/AdmissionIcon"),
    DashboardIcon: () => import("@components/icons/DashboardIcon"),
    InventoryIcon: () => import("@components/icons/InventoryIcon"),
    WebAppIcon: () => import("@components/icons/WebAppIcon"),
    StudentsAttendanceIcon: () => import("@components/icons/StudentAttendanceIcon"),
    StaffAttendanceIcon: () => import("@components/icons/StaffAttendanceIcon"),
    FinanceIcon : () => import("@components/icons/FinanceIcon"),
    PayrollIcon : () => import("@components/icons/PayRollIcon"),
    AcademicsIcon:() => import("@components/icons/AcademicsIcon"),
    HelpIcon:() => import("@components/icons/HelpIcon"),
  },
  methods: {
    ...mapActions(["closeDrawer"]),
  },
  computed: {
    ...mapGetters(["currentUser", "currentInstitution", "drawer"]),
    test() {
      return true;
    },
    navItems() {
      if (
        this.currentInstitution.erp_features.includes("[") &&
        this.currentInstitution.erp_features.includes("]")
      ) {
        var array = JSON.parse(this.currentInstitution.erp_features); //parse
        // iterate over list and get matching values
        return this.items.filter((i) => array.includes(i.id));
      }
      return [];
    },
    navDrawer: {
      get() {
        return this.drawer;
      },
      set(value) {
        if (!value) {
          this.closeDrawer();
        }
      },
    },
  },
  data: () => ({
    dialog: false,
    highlighted: 0,
    items: [
      {
        id: 0,
        model: false,
        icon: "DashboardIcon",
        text: "Dashboard",
        link: "/",
      },
      {
        id: 3,
        model: false,
        icon: "ClassroomsIcon",
        text: "Classrooms",
        link: "/classrooms",
        requiredPermission: 'canViewAllClassrooms'
      },
      {
        id: 1,
        model: false,
        icon: "StudentsIcon",
        text: "Students",
        link: "/students",
        requiredPermission: "canViewAllStudents"
      },
      { id: 2,
       model: false,
       icon: "StaffIcon",
       text: "Staff",
       requiredPermission: 'canViewAllStaff',
       alternateRequiredPermission: 'canCreateOwnDailyReports',
       children: [
          {
            text: "All Staff",
            exact: true,
            link: "/staff",
            requiredPermission: 'canViewAllStaff'
          },
          { text: "Daily Reports", exact: true, link: "/staff/daily-reports", requiredPermission: 'canCreateOwnDailyReports' },
        ],
      },
       
      {
        id: 4,
        icon: "FeesIcon",
        text: "Fees",
        link: "/fees",
        model: false,
        requiredPermission: 'canViewAllFeeAccounts',
        children: [
          {
            text: "Fee Accounts",
            exact: true,
            link: "/fees/records",
          },
          { text: "Fee Reports", exact: true, link: "/fees/reports", requiredPermission: "canViewFeeReports" },
          { text: "Fee Settings", exact: true, link: "/fees/settings", requiredPermission: "canManageFeeSettings" },

          //  { text: "ViewAdmissionDetails", exact: true, link: "/admissions/details" },
        ],
      },
      {
        id: 5,
        icon: "AdmissionsIcon",
        text: "Admissions",
        link: "/admissions",
        requiredPermission: 'canViewAdmissions',
        model: false,
        children: [
          { text: "All Admissions", exact: true, link: "/admissions", requiredPermission: 'canViewAdmissions' },
          { text: "Enquiry/Leads", exact: true, link: "/admissions?step=1", requiredPermission: 'canViewOwnEnquiries' },
          { text: "Applications", exact: true, link: "/admissions?step=2", requiredPermission: 'canViewApplications'  },
          { text: "Upload Documents", exact: true, link: "/admissions?step=3", requiredPermission: 'canViewUploadedDocuments'  },
          { text: "Evaluations", exact: true, link: "/admissions?step=4", requiredPermission: 'canEvaluateAdmissions'  },
          { text: "Confirmations", exact: true, link: "/admissions?step=5", requiredPermission: 'canViewConfirmations'  },
          { text: "Terminations", exact: true, link: "/admissions?step=6", requiredPermission: 'canViewTerminations'  },
        ],
      },
      {
        id: 6,
        icon: "InventoryIcon",
        text: "Inventory",
        link: "/inventory",
        model: false,
        requiredPermission: 'canViewInventoryDashboard',
        children: [
          {
            text: "Inventory Dashboard",
            exact: true,
            link: "/inventory/dashboard",
            requiredPermission: 'canViewInventoryDashboard',
          },
          { text: "Suppliers", exact: true, link: "/inventory/suppliers", requiredPermission: 'canViewAllSuppliers'},
          {
            text: "Purchase Orders",
            exact: true,
            link: "/inventory/purchase_orders",
            requiredPermission: 'canViewAllPurchaseOrders'
          },
          { text: "GRNs", exact: true, link: "/inventory/grns", requiredPermission: 'canViewAllGRNs' },
          {
            text: "Inventory Settings",
            exact: true,
            link: "/inventory/settings",
            requiredPermission: 'canManageInventorySettings'

          },
        ],
      },
      {
        id: 7,
        icon: "StudentsAttendanceIcon",
        text: "Student Attendance",
        link: "/attendance",
        requiredPermission: 'canViewAttendanceDashboard',
        model: false,
        children: [
          {
            text: "Attendance Dashboard",
            exact: true,
            link: "/attendance",
            requiredPermission: 'canViewAttendanceDashboard'
          },
          {
            text: "Attendance Details",
            exact: true,
            link: "/attendance/details",
          },
          {
            text: "Take Attendance",
            exact: true,
            link: "/attendance/take_attendance",
            requiredPermission: 'canTakeStudentAttendance'
          },
        ],
      },
      {
        id: 8,
        icon: "StaffAttendanceIcon",
        text: "Staff Attendance",
        link: "/staff-attendance",
        requiredPermission: 'canAccessStaffAttendance',
        model: false,
        children: [
          {
            text: "Attendance Dashboard",
            exact: true,
            link: "/staff-attendance",   
            requiredPermission: 'canViewStaffAttendanceData',      
          },
          {
            text: "Attendance Details",
            exact: true,
            link: "/staff-attendance/details",
            requiredPermission: 'canViewStaffAttendanceDetails',
          },
          {
            text: "Monthly Attendance",
            exact: true,
            link: "/staff-attendance/monthly",
            requiredPermission: 'canViewMonthlyStaffAttendanceDetails',
          },
          {
            text: "Quick Staff Attendance",
            exact: true,
            link: "/staff-attendance/quick-attendance",
            requiredPermission: 'canViewStaffAttendanceData',
          },
          {
            text: "Staff Calendar",
            exact: true,
            link: "/staff-attendance/calendar",
            requiredPermission: 'canViewStaffCalendar',
          },
          {
            text: "Staff Leave Record",
            exact: true,
            link: "/staff-attendance/leave/record",
            requiredPermission: 'canViewAllStaffsLeaveRecords',
          },
          {
            text: "Leave Account Details",
            exact: true,
            link: "/staff-attendance/leave/details",
            requiredPermission: 'canViewOwnLeaveAccountDetails',
          },
          {
            text: "Apply Leave",
            exact: true,
            link: "/staff-attendance/leave/apply",
            requiredPermission: 'canApplyLeaveForSelf',
          },
          {
            text: "Staff Settings",
            exact: true,
            link: "/staff-attendance/settings",
            requiredPermission: 'canViewStaffAttendanceSettings',
          },
        ],
      },
      {
        id: 9,
        icon: "PayrollIcon",
        text: "Payroll",
        link: "/payroll",
        requiredPermission: 'canViewPayrollDashboard',
        model: false,
        children: [
          {
            text: "Payroll Dashboard",
            exact: true,
            link: "/payroll/dashboard",
            requiredPermission: 'canViewPayrollDashboard',

          },
          {
            text: "Generate Payslips",
            exact: true,
            link: "/payroll/payslips/generate",
            requiredPermission: 'canGeneratePayrollPayslips',
          },
          {
            text: "Pending Payslips",
            exact: true,
            link: "/payroll/payslips/pending",
            requiredPermission: 'canViewPayrollPendingPayslips',
          },
          {
            text: "Approved Payslips",
            exact: true,
            link: "/payroll/payslips/approved",
            requiredPermission: 'canViewPayrollApprovedPayslips',

          },
          {
            text: "Rejected Payslips",
            exact: true,
            link: "/payroll/payslips/rejected",
            requiredPermission: 'canViewPayrollRejectedPayslips',
          },
          {
            text: "Payroll Settings",
            exact: true,
            link: "/payroll/settings",
            requiredPermission: 'canViewPayrollSettings',

          },
        ],
      },
      {
        id: 10,
        icon: "FinanceIcon",
        text: "Finances",
        link: "/finance",
        model: false,
        requiredPermission: 'canViewFinanceDashboard',
        children: [
          {
            text: "Finance Dashboard",
            exact: true,
            link: "/finance/dashboard",
            requiredPermission: 'canViewFinanceDashboard'
          },
          {
            text: "All Accounts",
            exact: true,
            link: "/finance/accounts",
            requiredPermission: 'canViewFinanceAccounts',
          },
          {
            text: "All Transactions",
            exact: true,
            link: "/finance/transactions",
            requiredPermission: 'canViewAllFinanceTransactions',
          },
          {
            text: "Incomes",
            exact: true,
            link: "/finance/incomes",
            requiredPermission: 'canViewFinanceIncomeTransactions',
          },
          {
            text: "Expenses",
            exact: true,
            link: "/finance/expenses",
            requiredPermission: 'canViewFinanceExpenseTransactions',
          },
          {
            text: "Authorize Expenses",
            exact: true,
            link: "/finance/expenses/authorize",
            requiredPermission: 'canAuthorizeFinanceExpenseTransactions'

          },
          {
            text: "Transactions Report",
            exact: true,
            link: "/finance/transactions/report",
            requiredPermission: 'canViewFinanceTransactionReports',
          },
          {          
            text: "Finance Settings",
            exact: true,
            link: "/finance/settings/",
            requiredPermission: 'canManageFinanceSettings',
          },
          // {
          //   text: "Rejected Payslips",
          //   exact: true,
          //   link: "/finance/rejected_payslips",
          // },
        ],
      },
      {
        id: 11,
        icon: "AcademicsIcon",
        text: "Academics",
        link: "/academics",
        model: false,
        requiredPermission: 'canViewSyllabusOfAssignedSubjects',
        children: [
          {
            text: "Syllabus Planner",
            exact: true,
            link: "/academics/syllabus-planner",
            requiredPermission: 'canViewSyllabusOfAssignedSubjects'
          },
          {
            text: "Classroom Timetable",
            exact: true,
            link: "/academics/class-timetable",
            requiredPermission: 'canViewClassroomTimetable'
          },
          {
            text: "Staff Timetable",
            exact: true,
            link: "/academics/staff-timetable",
            requiredPermission: 'canViewStaffTimetable'
          },
          {
            text: "Custom Documents",
            exact: true,
            link: "/templating",
            requiredPermission: 'canViewSyllabusOfAssignedSubjects'
          },
          {
            text: "Generate Report Cards",
            exact: true,
            link: "/academics/generate-report-cards",
            // requiredPermission: 'canViewSyllabusOfAssignedSubjects'
          }
        ],
      },
      {
        id: 12,
        icon: "HelpIcon",
        text: "Help",
        link: "/help",
        model: false,
      },
    ],

    hrefItems: [
      {
        id: 99,
        model: false,
        icon: "WebAppIcon",
        text: "Web App",
        href: "https://web.intractapp.in/",
        target: "_blank",
      },
    ],
  }),
};
</script>
<style scoped>
/* path {
  fill: #686868;
  height: 30px;
  width: 30px;
} */
.v-list-item__icon {
  margin-left: 6px;
}

.nav-title { 
  white-space: break-spaces;
}

.v-list-item:hover .nav-title{
  font-weight: bold !important;
}

.v-list-item--active > .v-list-item__content > .nav-title {
  font-weight: bold;
}

#container2::-webkit-scrollbar {
  height: 100%;
  width: 100%;
  overflow: auto;
  padding-right: 20px;
  display: none;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}


</style>